import { isNonEmptyString } from './checks'

const scrollTo = ({
  offsetPosition,
  hrefValue
}: {
  offsetPosition: number
  hrefValue?: string
}): void => {
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  })

  if (isNonEmptyString(hrefValue)) {
    window.history.pushState(null, '', hrefValue)
  }
}

interface ScrollToHref {
  (props: {
    element: HTMLElement & { preventDefault: () => void }
    offset?: number
  }): void
}

export const scrollToHref: ScrollToHref = ({ element, offset = 0 }) => {
  const hrefValue = element.getAttribute('href') || ''
  const target = document.querySelector(hrefValue)

  if (target) {
    const elementPosition = target.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.scrollY + (offset || 0)

    scrollTo({ hrefValue, offsetPosition })
  }
}
